import React, {Component} from 'react';
export default class WhatIs extends Component {

    constructor(props) {
        super(props);

    }

    render() {
        return (
            // <div className="row" data-aos="fade-up" data-aos-duration="100">
            <div className="row" >
                <div className="col-lg-12">
                    <h6 className="title">¿Por qué existe Adopta un Animal?</h6>
                    <p>
                        Cada vez son más los perros y gatos que son abandonados en el mundo (
                        <a rel="nofollow" href="https://www.fundacion-affinity.org/observatorio/infografia-el-nunca-lo-haria-2019-estudio-abandono-adopcion-perros-gatos-espana" target="_blank">
                        más de 138.000 en 2018 según el último estudio de Fundación Afinity</a>) y desde
                        <span className="init-description" > Adopta un </span>
                        <span className="colored-logo ">animal </span>
                        tenemos como objetivo que ninguno de ellos se queden sin un hogar.
                        Queremos fomentar la adopción frente a la compra y generar un cambio en nuestra sociedad para alcanzar un mundo más
                        ético y justo para todos estos animales.
                    </p>
                </div>
            </div>
        );
    }
}